import { useState, useCallback } from 'react';
import { AxiosError } from 'axios';

import { AuthApi } from '../api';

export const useResetPassword = (): {
  error: string | null;
  success: boolean;
  loading: boolean;
  handleResetPassword: (values: { email: string }) => Promise<void>;
} => {
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleResetPassword = useCallback(
    async ({ email }: { email: string }) => {
      try {
        setLoading(true);
        setError(null);
        await AuthApi.resetPassword({ email });
        setSuccess(true);
      } catch (err) {
        const errorMessage = (err as unknown as AxiosError<string>).response
          ?.data;
        setError(errorMessage ?? 'Something went wrong. Please try again.');
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return { error, success, loading, handleResetPassword };
};
